// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__C5OZc","rightAdornment":"Header_rightAdornment__1ah5c"};